import React from "react";
import { Button, Drawer, Progress, notification, Popconfirm } from "antd";
import { Label, Input, CustomInput } from "reactstrap";
import { storage } from "../../../firebase";
import { Form, Row, Col } from "antd";
import { Editor } from "@tinymce/tinymce-react";
import QuizDrawer from "./quizDrawer.js";
import { WarningTwoTone, CloseOutlined } from "@ant-design/icons";
import "./styles.css";

export default class EditableTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      childrenDrawer: false,
      fireBaseTransfer: false,
      errors: {},
      topicTitle: "",
      topicDetail: "",
      topicPdfUrl: "",
      topicAudioUrl: "",
      topicVideoUrl: "",
      quiz: [],
      titleEntered: false,
      topicPdfProgress: 0,
      topicPdf: "",
      topicThumbnailImage: "",
      topicThumbnailProgress: 0,
      topicThumbnailImageUrl: "",
      topicAudioProgress: 0,
      topicAudio: "",
      topicVideoProgress: 0,
      topicVideo: "",
      visible2: true,
    };
  }

  componentDidMount() {
    let test = this.props.editableTopic;
    console.log(test);
  }

  notActiveNotification = () => {
    let placement = "bottomRight";
    const key = `open${Date.now()}`;
    notification.open({
      duration: 5,
      message: "Attention Champion!",
      description: (
        <div id="loading">
          <h3>This feature is under development.</h3>
          <p>Please visit again later, Thanks.</p>
        </div>
      ),
      placement,
      icon: <WarningTwoTone twoToneColor="#BF2F2F" />,
      key,
    });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  editSelectedQuiz = (quiz) => {
    console.log(quiz);
  };

  deleteQuiz = (index) => {
    this.state.quiz.splice(index, 1);
    this.setState({ quiz: this.state.quiz });
    // console.log(this.state.quiz);
  };

  resetForm = () => {
    this.setState({
      errors: {},
      topicTitle: "",
      topicDetail: "",
      topicPdfUrl: "",
      topicAudioUrl: "",
      topicVideoUrl: "",
      titleEntered: false,
      topicPdfProgress: 0,
      topicPdf: "",
      topicAudioProgress: 0,
      topicAudio: "",
      quiz: [],
      topicThumbnailImage: "",
      topicThumbnailProgress: 0,
      topicThumbnailImageUrl: "",
    });
  };

  saveTopic = () => {
    const { topicTitle, topicDetail } = this.state;
    const error = {};
    let errorFound = false;
    if (topicTitle === "") {
      errorFound = true;
      error.topicTitle = "Please enter Topic Name";
    }
    if (topicDetail === "") {
      errorFound = true;
      error.topicDetail = "Please enter Topic Description";
    }
    this.setState({
      errors: error,
    });
    if (errorFound === false) {
      this.props.onSubmit(this.state);
      this.onChildrenDrawerClose();
      this.resetForm();
    }
  };

  // showChildrenDrawer = () => {
  //   this.setState({
  //     childrenDrawer: true,
  //   });
  // };

  // onChildrenDrawerClose = () => {
  //   this.setState({
  //     childrenDrawer: false,
  //   });
  // };

  handlePdfFiles = (e) => {
    if (e.target.files[0]) {
      this.setState({ topicPdf: e.target.files[0] }, () => {
        this.handelPdfUpload();
      });
    }
  };

  saveQuiz = (quiz) => {
    const temp = this.state.quiz;
    temp.push({
      question: quiz.question,
      options: quiz.options,
      points: quiz.points,
      correct: quiz.correct,
    });
    this.setState({
      quiz: temp,
    });
    console.log(this.state);
  };

  handleAudioFiles = (e) => {
    if (e.target.files[0]) {
      this.setState({ topicAudio: e.target.files[0] }, () => {
        this.handelAudioUpload();
      });
    }
  };

  handleFiles = (e) => {
    if (e.target.files[0]) {
      this.setState({ topicThumbnailImage: e.target.files[0] }, () => {
        this.handelUpload();
      });
    }
  };

  handelUpload = () => {
    const { topicThumbnailImage, topicTitle } = this.state;
    this.setState({ fireBaseTransfer: true });
    const uploadScreenshot = storage
      .ref(`lte/TopicThumbnails/${topicTitle}`)
      .put(topicThumbnailImage);

    uploadScreenshot.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        this.setState({ topicThumbnailImageProgress: progress });
      },
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref("lte/TopicThumbnails")
          .child(topicTitle)
          .getDownloadURL()
          .then((url) => {
            this.setState({
              topicThumbnailImageUrl: url,
              fireBaseTransfer: false,
            });
          });
      }
    );
  };

  handelPdfUpload = () => {
    const { topicPdf, topicTitle } = this.state;
    this.setState({ fireBaseTransfer: true });
    const uploadScreenshot = storage
      .ref(`lte/TopicPdf/${topicTitle}`)
      .put(topicPdf);

    uploadScreenshot.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        this.setState({ topicPdfProgress: progress });
      },
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref("lte/TopicPdf")
          .child(topicTitle)
          .getDownloadURL()
          .then((url) => {
            this.setState({ topicPdfUrl: url, fireBaseTransfer: false });
          });
      }
    );
  };

  handelAudioUpload = () => {
    const { topicAudio, topicTitle } = this.state;
    this.setState({ fireBaseTransfer: true });
    const uploadScreenshot = storage
      .ref(`lte/TopicAudio/${topicTitle}`)
      .put(topicAudio);

    uploadScreenshot.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        this.setState({ topicAudioProgress: progress });
      },
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref("lte/TopicAudio")
          .child(topicTitle)
          .getDownloadURL()
          .then((url) => {
            this.setState({ topicAudioUrl: url, fireBaseTransfer: false });
          });
      }
    );
  };

  handleEditorChange = (e) => {
    // console.log(e.target.getContent());
    this.setState({ topicDetail: e.target.getContent() });
  };

  onClose = () => {
    document.getElementById("create-user-form").reset();
    this.setState({
      visible2: false,
    });
    this.setState({
      visible2: false,
    });
  };

  render() {
    const { errors, visible2 } = this.state;
    return (
      <div>
        <Drawer
          width={620}
          visible={this.props.topicDrawer}
          onClose={this.onClose}
          title="Add New Topic"
          footer={[
            <Row gutter={24}>
              <Col span={12}>
                {" "}
                <Button
                  className="mButton"
                  key="submit"
                  type="primary"
                  disabled={this.state.fireBaseTransfer}
                  onClick={this.saveTopic}
                >
                  {this.state.fireBaseTransfer === false
                    ? "Submit"
                    : "Uploading File"}
                </Button>
              </Col>
              <Col span={12}>
                <QuizDrawer onSubmit={this.saveQuiz} />
              </Col>
            </Row>,
          ]}
        >
          <Form id="topicForm" layout="vertical" hideRequiredMark>
            <Row>
              <Col span={24}>
                <Form.Item label="Topic Name">
                  <Input
                    id="topicTitle"
                    name="topicTitle"
                    onChange={this.onChange}
                    value={this.state.topicTitle}
                    placeholder="Please enter Topic Name"
                  />
                  <Label className="red">{errors.topicTitle}</Label>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={24}>
                <Editor
                  initialValue={this.state.topicDetail}
                  apiKey="ghrpxealk6vlmuwhx63cv17ffqlsamcu8hjnccyjhtvjkdsb"
                  init={{
                    height: 250,
                    menubar: true,
                    plugins: [
                      "advlist autolink lists link image",
                      "charmap print preview anchor help",
                      "searchreplace visualblocks code",
                      "insertdatetime media table paste wordcount",
                    ],
                    toolbar:
                      // eslint-disable-next-line
                      "undo redo | formatselect | bold italic | \
            alignleft aligncenter alignright | \
            bullist numlist outdent indent | help",
                  }}
                  onChange={this.handleEditorChange}
                />
              </Col>
              <Label className="red">{errors.topicDetail}</Label>
            </Row>
            <br />

            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label="Attach Audio"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <CustomInput
                    disabled={this.state.topicTitle === "" ? true : false}
                    type="file"
                    accept="audio/x-m4a"
                    id="exampleCustomFileBrowser"
                    name="customFile"
                    label="Upload Audio"
                    onChange={this.handleAudioFiles}
                  >
                    <Progress percent={this.state.topicAudioProgress} />
                  </CustomInput>
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label="Attach Pdf"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <CustomInput
                    disabled={this.state.topicTitle === "" ? true : false}
                    type="file"
                    accept="application/pdf"
                    id="exampleCustomFileBrowser"
                    name="customFile"
                    label="Upload a Pdf"
                    onChange={this.handlePdfFiles}
                  >
                    <Progress percent={this.state.topicPdfProgress} />
                  </CustomInput>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label="Video Url">
                  <Input
                    id="topicVideoUrl"
                    name="topicVideoUrl"
                    onChange={this.onChange}
                    value={this.state.topicVideoUrl}
                    placeholder="Enter Topic video url"
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label="Topic Thumbnail Image"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <CustomInput
                    disabled={this.state.topicTitle === "" ? true : false}
                    type="file"
                    // accept="image/*"
                    id="exampleCustomFileBrowser"
                    name="customFile"
                    label="Upload a Thumbnail"
                    onChange={this.handleFiles}
                  >
                    <Progress
                      percent={this.state.topicThumbnailImageProgress}
                    />
                  </CustomInput>
                  <Label className="red">{errors.topicThumbnailImageUrl}</Label>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={24}>
                <Form.Item label={"Topic Quizes : " + this.state.quiz.length}>
                  <div className="scrollableDiv2 tc">
                    {this.state.quiz.map((item, key) => {
                      return (
                        <Row>
                          <h6
                            className="topicTab"
                            onClick={() => {
                              this.editSelectedQuiz(item);
                            }}
                          >
                            {key + 1 + " | " + item.question}
                          </h6>
                          <Popconfirm
                            placement="right"
                            title="Remove Quiz ？"
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => {
                              this.deleteQuiz(key);
                            }}
                          >
                            <CloseOutlined
                              type="Delete MCQ"
                              title="Delete MCQ"
                              style={{ fontSize: "23px", color: "red" }}
                              theme="outlined"
                            />
                          </Popconfirm>
                        </Row>
                      );
                    })}
                  </div>
                  <Label className="red">{errors.courseTopics}</Label>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </div>
    );
  }
}
